import React, { Component } from "react";
import { connect } from 'dva';
import Container from "@/components/Container";
import Iframe from "@/components/Iframe";

@connect(({ user }) => ({
  ...user,
}))
export default class PickCourse extends Component {
  render() {
    const { orgId } = this.props.currentUser;

    if (!orgId) {
      return null
    }

    const IframeDom = Iframe({
      src: `//rdp3.xiaoyuanhao.com/RDP-SERVER/rdppage/main/e7da666006b2266edab3f18914d27bb7?orgId=${orgId || '330108-S000351'}`
    });

    return (
      <Container breStates>
        <IframeDom />
      </Container>
    );
  }
}
